import { render, staticRenderFns } from "./JcomBusinessCategoryList.vue?vue&type=template&id=f93557fa"
import script from "./JcomBusinessCategoryList.vue?vue&type=script&lang=js"
export * from "./JcomBusinessCategoryList.vue?vue&type=script&lang=js"
import style0 from "./JcomBusinessCategoryList.vue?vue&type=style&index=0&id=f93557fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports